import * as React from "react";
import { Grid } from "semantic-ui-react";
import TlgQaColumn from "./TlgQaColumn";
import TlgProdColumn from "./TlgProdColumn";
import LotaProdColumn from "./LotaProdColumn";
import ApprovalBar from "./ApprovalBar";

type KanbanBoardProps = {
  licenseUploadStatus: State.LicenseUploadState;
  isApprover: boolean;
  onUpload: (jsonContent: string) => void;
  onPushToProd: () => void;
  onRequestLota: (comment: string) => void;
  onApprove: () => void;
  onReject: (reason: string) => void;
};

class KanbanBoard extends React.Component<KanbanBoardProps> {
  render(): JSX.Element {
    const {
      licenseUploadStatus,
      isApprover,
      onUpload,
      onPushToProd,
      onRequestLota,
      onApprove,
      onReject,
    } = this.props;

    return (
      <div>
        {isApprover && (
          <ApprovalBar
            approval={licenseUploadStatus.approval}
            isPushing={licenseUploadStatus.isPushing}
            onApprove={onApprove}
            onReject={onReject}
          />
        )}
        <Grid columns={3} stackable divided>
          <Grid.Column>
            <TlgQaColumn
              tlgQa={licenseUploadStatus.tlgQa}
              isUploading={licenseUploadStatus.isUploading}
              uploadError={licenseUploadStatus.uploadError}
              isPushing={licenseUploadStatus.isPushing}
              onUpload={onUpload}
              onPushToProd={onPushToProd}
            />
          </Grid.Column>
          <Grid.Column>
            <TlgProdColumn
              tlgProd={licenseUploadStatus.tlgProd}
              isPushing={licenseUploadStatus.isPushing}
              onRequestLota={onRequestLota}
            />
          </Grid.Column>
          <Grid.Column>
            <LotaProdColumn
              lotaProd={licenseUploadStatus.lotaProd}
              approval={licenseUploadStatus.approval}
            />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default KanbanBoard;
